import React, { useRef, useState } from 'react';
import { Animated, StyleSheet, Button, Dimensions } from 'react-native';
import { WebView } from 'react-native-webview';
import { usePersistBoundStore, usePersistSecureBoundStore } from '@/services/zustand/Store';
import { useLocalSearchParams, useRouter } from 'expo-router';
import OnboardingOverlay from '../Onboarding';
import { useHandleNotificationEntry } from '@/services/notifications/useHandleNotificationEntry';
import { useGetUser } from '@/services/apis/typo3/useGetUser';
import { useCheckForSessionCookies } from '@/services/apis/typo3/useCheckForSessionCookies';
import { GetUserResponse } from '@/services/datatypes/api';
import { User } from '@/services/datatypes/auth';
import { useLogin } from '@/services/auth/useLogin';

interface WebViewNavState {
  canGoBack: boolean;
  canGoForward: boolean;
}

export default function HomeScreenComponent() {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(true);
  const [position] = useState(new Animated.Value(0));
  const { webViewURL } = useLocalSearchParams();
  const token = usePersistBoundStore((state) => state.token);
  const reset = usePersistBoundStore((state) => state.resetOnboarding);
  const webViewRef = useRef<WebView>(null);
  const user = usePersistSecureBoundStore((state) => state.user);
  const logout = usePersistSecureBoundStore((state) => state.logout);
  const updateUser = usePersistSecureBoundStore((state) => state.updateUser);
  const { login } = useLogin();
  const { getUser } = useGetUser();
  const { checkForSessionCookies } = useCheckForSessionCookies();

  const handleMessage = async (event: any) => {
    const msg = JSON.parse(event.nativeEvent.data)
    await login(msg.user, msg.pass)
  };

  const injectedJavaScript = `
    (function() {
      const form = document.querySelector('form');
      if (form) {
        form.addEventListener('submit', function(event) {
          const formData = new FormData(form);
          const formDataObj = {};
          formData.forEach((value, key) => (formDataObj[key] = value));

          window.ReactNativeWebView.postMessage(JSON.stringify(formDataObj));
        });
      }
    })();
  `;

  const handleNavigationEvent = async (navState: WebViewNavState) => {
    const newToken = await checkForSessionCookies();
    const response: GetUserResponse = await getUser(newToken ?? token);
    //console.log("HomeScreen.tsx handleNavigationEvent response: ", response)
    if (response && response.uid) {
      const newUser: User = {
        id: response.uid,
        name: response.username,
        permissions: ['user'],
        subscriptions: null,
      }
      updateUser(newUser);
    } else {
      logout();
    }
  }

  const baseUrl = 'https://Relaunch2023:Mp9zvcBkxUuabmm9FhdT@staging.boyens-api.de/';
  let fullUrl = '';
  if (webViewURL) {
    fullUrl = `${baseUrl}${webViewURL}`;
  } else {
    fullUrl = baseUrl;
  };

  return (
    <>
      <OnboardingOverlay page="homescreen" />
      <WebView
        ref={webViewRef}
        style={{ flex: 1, width: Dimensions.get('window').width, height: Dimensions.get('window').height }}
        source={{ uri: fullUrl }}
        webviewDebuggingEnabled={true}
        allowsFullscreenVideo={true}
        allowsInlineMediaPlayback={true}
        allowsBackForwardNavigationGestures={true}
        pullToRefreshEnabled={true}
        mediaPlaybackRequiresUserAction={false}
        sharedCookiesEnabled={true}
        thirdPartyCookiesEnabled={true}
        javaScriptEnabled={true}
        domStorageEnabled={true}
        startInLoadingState={true}
        onNavigationStateChange={handleNavigationEvent}
        onMessage={handleMessage}
        injectedJavaScript={injectedJavaScript}
      />
      {isVisible && (
        <Animated.View
          style={[styles.buttonContainer, { opacity: position.interpolate({ inputRange: [0, 1], outputRange: [1, 0] }) }]}
        >
          <Button title="Reset onBoarding" onPress={reset} />
        </Animated.View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  buttonContainer: {
    position: 'absolute',
    bottom: 20,
    left: '3%',
  },
});
